import { render, staticRenderFns } from "./OCTextBox.html?vue&type=template&id=2469a764&scoped=true&"
import script from "./OCTextBox.ts?vue&type=script&lang=ts&"
export * from "./OCTextBox.ts?vue&type=script&lang=ts&"
import style0 from "./OCTextBox.css?vue&type=style&index=0&id=2469a764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2469a764",
  null
  
)

export default component.exports